module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAYCAYAAAAh8HdUAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEwSURBVDhPjZShbgJBFEU3BIFAVCCQFQgEEomoQCKRlQgk/1CB7CcgEZWISgSfgKisIUFUVCAQJLs9M+92Awtv4CSTeW/veQQmw2ZFUTTyPF+x5tmjIC8YjFC/63EaxE/NROhninzwmohbGzHop4p98NqIXzYSh06ssWIf3GfEvY3ZINtQsQ9SF/knTgH1gW2g2CdIkiPUv2xdxT5IL/p6Eeo9q6PYB2lcGQwH1VbsgzixEUODTcU+iDMbMejXNWUpdtr/aWm/DZ86Yl0cCJv/uwirRx8G/KNH6FUGDqy+4mtwwq04v05HNv9WEIaL+x1toE5fXJwWQnnTA/Sviq8hD/+pjakGvf9nJK8jrE016N8U3wahfEcE6O+/J5DKdwT1hx6nwX1C3rKW1HU9TpBlf7/80t9FjrXzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/u1678.png
// module id = J01e
// module chunks = 0